<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="first"
      >
        <h2 class="el_h2">基础信息</h2>
        <!-- 查询表单 -->
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="120px"
        class="search_form"
        >
          <el-form-item label="温控点类型" prop="pointType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.pointType"
            placeholder="请选择温控点类型"
            clearable
            >
              <el-option
              v-for="item in pointType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="温控点名称/编号" prop="pointName">
            <el-input placeholder="请输入温控点名称/编号" v-model="search_form.pointName"></el-input>
          </el-form-item>
          <!-- <el-form-item label="温控点编号" prop="pointNumber">
            <el-input placeholder="请输入温控点编号" v-model="search_form.pointNumber"></el-input>
          </el-form-item> -->
          <el-form-item label="仓库名称" prop="warehouse">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="true"
            v-model="search_form.warehouse"
            placeholder="请选择"
            clearable
            @change="change_warehouse"
            >
              <el-option
              v-for="item in warehouse_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仓库区域" prop="area">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.area"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in area_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
          label="显示失效设备"
          prop="show_device">
            <el-switch
            active-value="Y"
            inactive-value="N"
            v-model="search_form.show_device"
            ></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button
            @click="search_storage(true)"
            type="primary"
            >查询</el-button>
            <el-button
            @click="reset_storage"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="second"
      >
        <el-table
        ref="manage_table"
        v-loading="list_loading"
        :data="list_data"
        highlight-current-row
        border
        @row-click="left_click"
        @row-contextmenu="right_click"
        max-height="500"
        >
          <el-table-column fixed="left" type="selection"></el-table-column>
          <el-table-column type="index" align="center" label="NO"></el-table-column>
          <el-table-column
          align="center"
          min-width="100"
          prop="pointWarehouseName"
          label="仓库名称"></el-table-column>
          <el-table-column
          align="center"
          min-width="100"
          prop="pointAreaName"
          label="仓库区域"></el-table-column>
          <el-table-column
          align="center"
          min-width="160"
          prop="pointName"
          show-overflow-tooltip
          label="温控点名称"></el-table-column>
          <el-table-column
          align="center"
          min-width="160"
          prop="pointId"
          show-overflow-tooltip
          label="温控点编号"></el-table-column>
          <el-table-column
          align="center"
          min-width="100"
          prop="pointTypeText"
          label="温控点类型"></el-table-column>
          <el-table-column
          align="center"
          min-width="100"
          label="是否已启用">
            <template slot-scope="scope">
              <span>{{scope.row.activeFlag=='Y'?'是':'否'}}</span>
            </template>
          </el-table-column>
          <el-table-column
          fixed="right"
          align="center"
          min-width="160"
          prop="addTime"
          label="创建时间"></el-table-column>
        </el-table>
        <!-- 库房管理列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="pageparm_size_change"
        @current-change="pageparm_current_change"
        :current-page="pageparm.currentPage"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pageparm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageparm.total"
        ></el-pagination>
        <!-- 库房管理右键菜单 -->
        <div id="warehouse_menu">
          <ul>
            <li @click="check_warehouse_temp">
              <span>查看温度</span>
            </li>
          </ul>
        </div>
        <!-- 时间范围弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="time_range_show"
        title="选择时间范围"
        v-dialogDrag
        >
          <el-form
          :model="time_form"
          label-width="120px"
          >
            <el-form-item label="开始时间从" prop="date_range">
              <el-date-picker
              type="datetimerange"
              v-model="time_form.date_range"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%;"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              @change="date_range_change"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
              type="primary"
              @click="confirm_date_range">确认</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane
      label="温度数据"
      name="third"
      style="overflow-x: auto;"
      >
        <!-- echarts曲线数据 -->
        <div id="chart" ref="my_echarts" v-show="chart_or_draw==false">
          <canvas></canvas>
        </div>
        <!-- 手绘曲线数据 -->
        <div style="text-align: center;" class="controlToEdit" v-show="chart_or_draw==true">
          <div style="margin-bottom: 15px;">
            <span>当前鼠标所在温度:{{mouseCurrentTemp}}</span>
            <el-button size="mini" type="warning" class="reDrawing" @click="reDrawing()">重画</el-button>
            <el-button size="mini" type="success" class="confirmDrawing" @click="confirmDrawing()">确认</el-button>
            <el-button size="mini" class="backToCharts" @click="reBack()">返回</el-button>
          </div>
          <div style="position: relative;">
            <canvas
            id="manualDrawingCanvas"
            width="1000px"
            height="400"
            style="border:1px solid black;zoom: 1.25;">
            </canvas>
            <span v-show="scale_position_show==true"
            :style="{
              left: canvas_span_left+'px',
              top: scale_left_position*1.25-7+'px',
              position: 'absolute',
              color:'red'
            }"
            >←{{scale_left}}</span>
            <span v-show="scale_position_show==true"
            :style="{
              right: canvas_span_left+'px',
              top: scale_right_position*1.25-7+'px',
              position: 'absolute',
              color:'red'
            }"
            >{{scale_right}}→</span>
          </div>
        </div>
        <div class="chart_btn_group">
          <i :title="draw_title"
          :class="{'draw_edit_ture':draw_status==true}"
          class="el-icon-edit"
          v-if="btn_permission.includes('middle:warehousePoint:saveData')||btn_permission.includes('superAdmin')"
          @click="draw_curve"></i>
          <i title="上移"
          class="el-icon-top"
          v-if="draw_move_btn==true&&btn_permission.includes('middle:warehousePoint:move')||draw_move_btn==true&&btn_permission.includes('superAdmin')"
          @click="draw_move_up"></i>
          <i title="下移"
          class="el-icon-bottom"
          v-if="draw_move_btn==true&&btn_permission.includes('middle:warehousePoint:move')||draw_move_btn==true&&btn_permission.includes('superAdmin')"
          @click="draw_move_down"></i>
          <i title="保存数据"
          class="el-icon-folder-checked"
          v-if="btn_permission.includes('middle:warehousePoint:saveData')||btn_permission.includes('superAdmin')"
          @click="save_data"></i>
          <i title="曲线明细"
          class="el-icon-document"
          v-if="choice_area==true"
          @click="get_curve_list"></i>
        </div>
        <!-- 曲线明细弹框 -->
        <el-dialog
        :append-to-body="true"
        :visible.sync="curve_show"
        :title="temperature_name+' 的曲线明细'"
        v-dialogDrag
        >
          <el-table
          :data="curve_detail_data"
          highlight-current-row
          border
          max-height="500"
          >
            <el-table-column
            align="center"
            prop="recordTime"
            label="时间"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="temperature"
            :label="temperature_unit=='%'?'湿度(%)':'温度(°C)'"
            ></el-table-column>
          </el-table>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default{
    data() {
      return{
        //路由传参
        router_params:{},
        //权限数组
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        //切换tab
        activeName:'first',
        //温控点类型下拉框
        pointType_list:[],
        //仓库名称下拉框
        warehouse_list:[],
        //仓库区域下拉框
        area_list:[],
        //查询表单
        search_form:{
          pointType:'',
          pointName:'',
          // pointNumber:'',
          warehouse:'',
          area:'',
          show_device:'N'
        },
        //懒加载
        list_loading:false,
        // 库房管理列表
        list_data:[],
        //库房管理列表分页
        pageparm:{
          currentPage: 1,
          pageSize: 10,
          total: 1
        },
        //当前行数据
        row_cold_now:{},
        //选中的行数组
        selected_row_list:'',
        //时间范围弹框
        time_range_show:false,
        time_form:{
          date_range:'',
          begin_time:'',
          end_time:'',
        },
        //限定查询表单时间范围在32天以内
        truck_select_date:'',
        pickerOptions:{
          onPick:({maxDate,minDate})=>{
            this.truck_select_date=minDate.getTime()
            if(maxDate){
              this.truck_select_date=''
            }
          },
          disabledDate:(time)=>{
            if(this.truck_select_date!=''){
              const one=31*24*3600*1000
              const minTime=this.truck_select_date-one
              const maxTime=this.truck_select_date+one
              return time.getTime()<minTime||time.getTime()>maxTime
            }
          }
        },
        //温度数据相关
        //echarts实例
        myChart:'',
        //echarts曲线图和手绘板的显影
        chart_or_draw:false,
        //是否为手绘
        isCustom:'N',
        //手绘是否结束
        hasOver:'Y',
        //选择区域时间范围
        params_start:'',//选择曲线区域后的开始时间
        params_end:'',//选择曲线区域后的结束时间
        params_start_range:'',//选择曲线区域的起始位置
        params_end_range:'',//选择曲线区域的结束位置
        scale_left:0,//选择曲线区域后的开始温度
        scale_right:0,//选择曲线区域后的结束温度
        scale_left_position:0,//开始温度在canvas上的定位top值
        scale_right_position:0,//结束温度在canvas上的定位top值
        canvas_span_left:0,
        //开始温度、结束温度定位显影
        scale_position_show:false,
        //选择区域工具显影
        choice_area:false,
        //温度上限
        maxTemperature:'',
        //温度下限
        minTemperature:'',
        //温度数据ID
        temperature_title:'',
        //温度数据名称
        temperature_name:'',
        //温度数据单位
        temperature_unit:'',
        //上移下移按钮显影
        draw_move_btn:false,
        //上移上移的第一次操作
        up_down_first:true,
        //获取温度数据
        tempData:{},
        //时间戳和温度数组
        new_temp_list:[],
        selected_item:[],
        selected_temp_list:[],
        //绘制按钮点击状态
        draw_status:false,
        draw_title:'绘制曲线',
        drawXPoint:[],
        drawYPoint:[],
        sTime:'',
        eTime:'',
        timeInterval:60,
        marginLeft:50,
        inclusiveAmount:2,//包容量。用于打点的时候允许像素偏差范围
        canvas:'',
        cxt:'',//画板绘图对象
        canvasWidth:'',//画板宽度
        canvasHeight:'',//画板高度
        totalPoint:0,//总共需要’打点‘的坐标数量
        currentPoint:'',//当前第几个点
        shouldPoint:1,//应该打第几个点
        shouldBeIndex:0,//应该去哪个坐标
        interval:'',//间隔量，用于计算下一x轴位置
        isMouseDown:false,//鼠标是否为按下状态
        mouseCurrentTemp:0,//当前鼠标所在温度
        //曲线明细弹框显影
        curve_show:false,
        //曲线明细列表
        curve_detail_list:[],
        //曲线明细数据
        curve_detail_data:[]
      }
    },
    created() {
      //温控点类型下拉框
      this.get_devicetype()
      //仓库名称下拉框
      this.get_warehouse()
      //路由传参
      if(this.$route.query.row){
        this.router_params=this.$route.query.row
        this.$nextTick(()=>{
          if(this.router_params.deviceId){
            this.time_form.date_range=[this.router_params.time_range[0],this.router_params.time_range[1]]
            this.search_form.pointName=this.router_params.deviceId
          }else{
            let now_date=this.publicAjax.dateFormatter(new Date(),'yyyy-MM-dd')
            this.time_form.date_range=[now_date+' 00:00:00',now_date+' 23:59:59']
            this.search_form.pointName=this.router_params.pointName
            this.search_form.warehouse=this.router_params.warehouseId
            //仓库名称change事件
            this.change_warehouse(this.search_form.warehouse)
            this.search_form.area=this.router_params.areaId
          }
          //查询库房管理列表
          this.search_storage()
        })
      }
    },
    updated() {
      this.changeBox()
    },
    mounted() {
      window.addEventListener('resize',this.changeBox,true)
    },
    watch:{
      '$route'(to,from){
        if(to.name=='warehouse_manage'&&this.$route.query.row){
          this.router_params=this.$route.query.row
          if(this.router_params.deviceId){
            this.time_form.date_range=[this.router_params.time_range[0],this.router_params.time_range[1]]
            this.search_form.pointName=this.router_params.deviceId
          }else{
            let now_date=this.publicAjax.dateFormatter(new Date(),'yyyy-MM-dd')
            this.time_form.date_range=[now_date+' 00:00:00',now_date+' 23:59:59']
            this.search_form.pointName=this.router_params.pointName
            this.search_form.warehouse=this.router_params.warehouseId
            //仓库名称change事件
            this.change_warehouse(this.search_form.warehouse)
            this.search_form.area=this.router_params.areaId
          }
          //查询库房管理列表
          this.search_storage()
        }
      }
    },
    methods:{
      changeBox(){
        this.canvas_span_left=document.querySelector('#manualDrawingCanvas').offsetLeft
      },
      //温控点类型下拉框
      get_devicetype(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/dict/select/byCode/pointType'
        }).then(data=>{
          if(data.data.success==true){
            that.pointType_list=data.data.data
          }
        })
      },
      //仓库名称下拉框
      get_warehouse(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/user/select/warehouse'
        }).then(data=>{
          if(data.data.success==true){
            that.warehouse_list=data.data.data
          }else{
            that.$message({
              type:'warning',
              message:data.data.message
            })
            that.warehouse_list=[]
          }
        })
      },
      //仓库名称change事件
      change_warehouse(value){
        //仓库区域下拉框
        this.get_area(value)
      },
      //仓库区域下拉框
      get_area(value){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehouse/zoneGroup/'+value
        }).then(data=>{
          if(data.data.success==true){
            that.area_list=data.data.data
          }else{
            that.$message({
              type:'warning',
              message:data.data.message
            })
            that.area_list=[]
          }
        })
      },
      //开始时间change事件
      date_range_change(value){
        if(value!=null){
          this.time_form.begin_time=value[0]
          this.time_form.end_time=value[1]
        }else{
          this.time_form.begin_time=''
          this.time_form.end_time=''
        }
      },
      //库房管理列表
      storage_list(){
        let that=this
        that.list_loading=true
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/list',
          params:{
            warehouseId:that.search_form.warehouse,
            pointKey:that.search_form.pointName,
            pointType:that.search_form.pointType,
            pointAreaId:that.search_form.area,
            activeFlag:that.search_form.show_device,
            page:that.pageparm.currentPage,
            limit:that.pageparm.pageSize
          }
        }).then(data=>{
          that.list_loading=false
          if(data.data.success==true){
            var truck_menu=document.querySelector('#warehouse_menu')
            truck_menu.style.display='none'
            that.list_data=data.data.data.list
            that.pageparm.total=data.data.data.total
            //重置手绘按钮点击状态
            that.draw_status=false
            that.chart_or_draw=false
            that.draw_title='绘制曲线'
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //库房管理列表分页
      pageparm_size_change(val){
        this.pageparm.pageSize=val
        //库房管理列表
        this.storage_list()
      },
      pageparm_current_change(val){
        this.pageparm.currentPage=val
        //库房管理列表
        this.storage_list()
      },
      //查询库房管理列表
      search_storage(router_status){
        if(router_status==true){
          let now_date=this.publicAjax.dateFormatter(new Date(),'yyyy-MM-dd')
          this.time_form.date_range=[now_date+' 00:00:00',now_date+' 23:59:59']
        }
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        this.activeName='second'
        //库房管理列表
        this.storage_list()
      },
      //重置库房管理查询表单
      reset_storage(){
        this.$refs['search_form'].resetFields()
        this.pageparm.currentPage=1
        this.pageparm.pageSize=10
        //库房管理列表
        this.storage_list()
      },
      //库房管理列表鼠标左键点击事件
      left_click(row,column,event){
        var menu=document.querySelector('#warehouse_menu')
        menu.style.display='none'
      },
      //库房管理列表鼠标右键点击事件
      right_click(row,column,event){
        this.row_cold_now=row
        event.preventDefault()
        var menu=document.querySelector('#warehouse_menu')
        //根据事件对象中鼠标点击的位置，进行定位
        let menu_top=document.body.clientHeight-event.clientY
        menu.style.left=event.clientX+'px'
        menu.style.top=event.clientY+'px'
        //改变自定义菜单的显示和隐藏
        menu.style.display='block'
        this.$refs['manage_table'].setCurrentRow(row)
      },
      //查看温度
      check_warehouse_temp(){
        var menu=document.querySelector('#warehouse_menu')
        menu.style.display='none'
        let selected_rows=this.$refs.manage_table.selection
        if(selected_rows.length>10){
          this.$message.warning('最多只可勾选10条数据！')
          return false
        }
        this.selected_row_list=''
        if(selected_rows.length==0){
          this.selected_row_list=this.row_cold_now.pointId
        }else{
          selected_rows.forEach((item,index)=>{
            if(selected_rows.length-1==index){
              this.selected_row_list+=item.pointId
            }else{
              this.selected_row_list+=item.pointId+','
            }
          })
        }
        this.isCustom='N'
        this.up_down_first=true
        this.draw_move_btn=false
        this.time_range_show=true
      },
      // 确定时间范围
      confirm_date_range(){
        if(this.time_form.date_range==''||this.time_form.date_range==null){
          this.$message.warning('请选择时间范围！')
          return false
        }
        this.time_range_show=false
        //获取温度数据
        this.get_temp()
      },
      //获取温度数据
      get_temp(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/pointData',
          params:{
            beginTime:that.time_form.date_range[0],
            endTime:that.time_form.date_range[1],
            pointIds:that.selected_row_list
          }
        }).then(data=>{
          if(data.data.success==true){
            if(data.data.data){
              if(data.data.data.length==1){
                this.maxTemperature=parseFloat(data.data.data[0][0].maxTemp)
                this.minTemperature=parseFloat(data.data.data[0][0].minTemp)
                this.temperature_title=data.data.data[0][0].deviceId
                this.temperature_name=data.data.data[0][0].deviceName
                this.temperature_unit=data.data.data[0][0].unit
                this.choice_area=true
              }else{
                this.choice_area=false
              }
              that.selected_item=data.data.data
              that.selected_temp_list=[]
              // 生成折线图
              that.get_myCharts(data.data.data)
            }else{
              //获取echarts实例
              that.myChart=that.$echarts.init(document.getElementById('chart'))
              that.myChart.clear()
            }
            that.activeName='third'
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //生成折线图
      get_myCharts(data_list,draw_now){
        //获取echarts实例
        document.getElementById('chart').removeAttribute('_echarts_instance_')
        this.myChart=this.$echarts.init(document.getElementById('chart'))
        this.myChart.clear()
        let that=this
        const colors=[
          '#ff3300','#66ff33','#009999','#000099','#ff33cc',
          '#990033','#ffff66','#336600','#cc33ff','#66ccff'
        ]
        that.new_temp_list=[]
        that.curve_detail_list=[]
        let series_new_list=[],yAxis_list=[],
        xAxis_list=[],xAxis_scale_list=[]
        let data_temp_list=data_list
        that.params_start=''
        that.params_end=''
        if(draw_now==true){
          data_temp_list.forEach(item=>{
            that.curve_detail_list.push({
              recordTime:item[0],
              temperature:item[1]
            })
          })
          xAxis_list.push({
            type:'category',
            axisLine: {
              onZero: false,
            },
            showMaxLable:true,//显示最大值
            showMinLable:true,//显示最小值
            axisTick: {
              alignWithLabel: true
            }
          })
          yAxis_list.push({
            type:'value',
            axisLine:{onZero:false}
            // max:parseFloat(item[0].maxTemp)+2,//y轴最大值
            // min:parseFloat(item[0].minTemp)-2//y轴最小值
          })
          series_new_list.push({
            id:'a0'+'-'+that.temperature_unit,
            name:that.temperature_name,
            type:'line',
            smooth:true,
            emphasis: {
              focus: 'series'
            },
            data:data_temp_list
          },
          {//温度下限(有效范围)
            id:'b',
            type:'line',
            smooth:false,
            itemStyle: {
                normal: {
                    lineStyle: {
                        color:colors[6],
                        width: 2,
                        type: 'dotted'  //'dotted'虚线 'solid'实线
                    }
                }
            },
            data:[[data_temp_list[0][0],that.minTemperature],[data_temp_list[data_temp_list.length-1][0],that.minTemperature]]
          },{//温度上限(有效范围)
            id:'c',
            type:'line',
            smooth:false,
            itemStyle: {
                normal: {
                    lineStyle: {
                        color:colors[6],
                        width: 2,
                        type: 'dotted'  //'dotted'虚线 'solid'实线
                    }
                }
            },
            data:[[data_temp_list[0][0],that.maxTemperature],[data_temp_list[data_temp_list.length-1][0],that.maxTemperature]]
          },
          )
        }else{
          data_temp_list.forEach((item,index)=>{
            that.new_temp_list.push([])
            xAxis_scale_list.push([])
            that.curve_detail_list.push([])
            item.forEach((item1,index1)=>{
              if(item1.temperature==null){
                item1.temperature=null
              }else{
                item1.temperature=parseFloat(item1.temperature).toFixed(1)
              }
              item1.recordTime=that.publicAjax.genDateFromStamp(item1.recordTime)
              that.new_temp_list[index].push([item1.recordTime,item1.temperature])
              xAxis_scale_list[index].push(item1.recordTime)
              that.curve_detail_list[index].push({
                recordTime:item1.recordTime,
                temperature:item1.temperature
              })
            })
            xAxis_list.push({
              type:'category',
              axisLine: {
                onZero: false
              },
              show:index==0?true:false,
              showMaxLable:true,//显示最大值
              showMinLable:true,//显示最小值
              axisTick: {
                alignWithLabel: true
              },
              data:xAxis_scale_list[index]
            })
            yAxis_list.push({
              type:'value',
              axisLine:{onZero:true}
              // max:parseFloat(item[0].maxTemp)+2,//y轴最大值
              // min:parseFloat(item[0].minTemp)-2//y轴最小值
            })
            series_new_list.push({
              name:item[0].deviceName,
              id:'a'+index+'-'+item[0].unit,
              type:'line',
              smooth:true,
              emphasis: {
                focus: 'series'
              },
              connectNulls:true,
              data:that.new_temp_list[index]
            },
            {//温度下限(有效范围)
              id:'b'+index,
              type:'line',
              smooth:false,
              itemStyle: {
                  normal: {
                      lineStyle: {
                          color:colors[6],
                          width: 2,
                          type: 'dotted'  //'dotted'虚线 'solid'实线
                      }
                  }
              },
              data:data_temp_list.length!=1?[]:[[that.new_temp_list[index][0][0],parseFloat(item[0].minTemp)],[that.new_temp_list[index][that.new_temp_list[index].length-1][0],parseFloat(item[0].minTemp)]]
            },{//温度上限(有效范围)
              id:'c'+index,
              type:'line',
              smooth:false,
              itemStyle: {
                  normal: {
                      lineStyle: {
                          color:colors[6],
                          width: 2,
                          type: 'dotted'  //'dotted'虚线 'solid'实线
                      }
                  }
              },
              data:data_temp_list.length!=1?[]:[[that.new_temp_list[index][0][0],parseFloat(item[0].maxTemp)],[that.new_temp_list[index][that.new_temp_list[index].length-1][0],parseFloat(item[0].maxTemp)]]
            })
          })
        }
        let option={
          color: colors,
          legend: {},
          xAxis:xAxis_list,
          yAxis:yAxis_list,
          dataZoom:[
            // {
            //   type:'inside',
            //   throttle:50
            // }
            {
                id: 'dataZoomX',
                type: 'inside',
                xAxisIndex: [0],
                filterMode: 'filter'
            },
            {
                id: 'dataZoomY',
                type: 'inside',
                yAxisIndex: [0],
                filterMode: 'empty'
            },
            {
                id: 'dataZoomXs',
                type: 'slider'
                , show: true
                , xAxisIndex: [0]
                , filterMode: 'filter'
                , textStyle: {
                    color: "#409EFF"
                    , fontWeight: 'lighter'
                    , fontStyle: 'italic'
                    , width: 30
                    , fontSize: 9
                    , overflow: "break"
                }
            },
            {
                id: 'dataZoomYs',
                type: 'slider',
                yAxisIndex: [0],
                filterMode: 'empty'
                , textStyle: {
                    color: "#409EFF", width: '2', overflow: "truncate"
                }
            }
          ],
          series:series_new_list,
          tooltip:{
            trigger: 'axis',
            //表示不使用默认的【显示】【隐藏】触发规则
            axisPointer:{
              type:'cross',
              snap:true,
              label:{
                backgroundColor:'#6a7985',
                precision:1
              }
            },
            formatter:function(params){
              let res=params[0].data[0]+'<br>'
              for(var i=0;i<params.length;i++){
                if(params[i].seriesId.indexOf('a')!=-1){
                  res+= params[i].marker+params[i].seriesName
                  +(params[i].seriesId.split('-')[1]=='%'?'<br>湿度：':'<br>温度：')
                  +parseFloat(params[i].data[1]).toFixed(1)
                  +(params[i].seriesId.split('-')[1]=='%'?'%<br>':"°c<br>")
                }
              }
              return res
            }
          },
          toolbox:{
            show:true,
            feature:{
              saveAsImage: {
                  show: true,
                  excludeComponents: ['toolbox'],
                  pixelRatio: 2
              }
            }
          },
          brush:that.choice_area==false?{}:{
            toolbox: ['lineX', 'clear'],
            xAxisIndex: 0,
            throttleType: 'debounce',
            throttleDelay: 600
          }
        }
        that.myChart.setOption(option)
        that.myChart.on('legendselectchanged',(params)=>{
          that.selected_item=[]
          for(let key in params.selected){
            if(params.selected[key]==true){
              that.selected_item.push({
                label:key,
                value:params.selected[key]
              })
            }
          }
          if(that.selected_item.length==1){
            that.selected_temp_list=[]
            that.curve_detail_list=[]
            that.myChart.setOption({
              brush:{
                toolbox: ['lineX', 'clear'],
                xAxisIndex: 0,
                throttleType: 'debounce',
                throttleDelay: 600
              }
            })
            that.choice_area=true
            data_temp_list.forEach(item=>{
              if(that.selected_item[0].label==item[0].deviceName){
                //温度上限
                that.maxTemperature=parseFloat(item[0].maxTemp)
                //温度下限
                that.minTemperature=parseFloat(item[0].minTemp)
                //温度数据ID
                that.temperature_title=item[0].deviceId
                //温度数据名称
                that.temperature_name=item[0].deviceName
                //温度数据单位
                that.temperature_unit=item[0].unit
                item.forEach(item1=>{
                  that.selected_temp_list.push([item1.recordTime,item1.temperature])
                  that.curve_detail_list.push({
                    recordTime:item1.recordTime,
                    temperature:item1.temperature
                  })
                })
              }
            })
          }else{
            that.choice_area=false
            that.myChart.setOption({
              brush:{}
            })
            that.myChart.dispatchAction({
              type:'brush',
              command:['clear'],
              areas:[]
            })
          }
        })
        that.myChart.off('brushSelected')
        that.myChart.on('brushSelected',(params)=>{
          if(params.batch.length==0){
            return false
          }
          if(params.batch[0].areas.length==0){
            that.draw_move_btn=false
            return false
          }
          that.draw_move_btn=true
          that.params_start_range=params.batch[0].areas[0].coordRange[0]
          that.params_end_range=params.batch[0].areas[0].coordRange[1]
          if(that.selected_temp_list.length==0){
            that.params_start=that.new_temp_list[0][that.params_start_range][0]
            that.params_end=that.new_temp_list[0][that.params_end_range][0]
            that.scale_left=that.new_temp_list[0][that.params_start_range][1]
            that.scale_right=that.new_temp_list[0][that.params_end_range][1]
          }else{
            that.params_start=that.selected_temp_list[that.params_start_range][0]
            that.params_end=that.selected_temp_list[that.params_end_range][0]
            that.scale_left=that.selected_temp_list[that.params_start_range][1]
            that.scale_right=that.selected_temp_list[that.params_end_range][1]
          }
        })
        that.myChart.on('brushEnd',(params)=>{
          if(params.areas.length==0){
            that.draw_move_btn=false
          }
        })
        window.addEventListener('resize',()=>{
          that.myChart.resize()
        })
      },
      //曲线上移下移共用函数
      draw_move_fn(up_or_down){
        let begin_time='',end_time='',
        change_begin_time='',change_end_time=''
        if(this.selected_item.length!=1){
          this.$message.warning('每次只允许绘制一条曲线')
          return false
        }
        if(this.selected_temp_list.length==0){
          begin_time=this.new_temp_list[0][0][0]
          end_time=this.new_temp_list[0][this.new_temp_list[0].length-1][0]
          change_begin_time=this.new_temp_list[0][this.params_start_range][0]
          change_end_time=this.new_temp_list[0][this.params_end_range][0]
        }else{
          begin_time=this.selected_temp_list[0][0]
          end_time=this.selected_temp_list[this.selected_temp_list.length-1][0]
          change_begin_time=this.selected_temp_list[this.params_start_range][0]
          change_end_time=this.selected_temp_list[this.params_end_range][0]
        }
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/warehousePoint/move',
          params:{
            pointId:this.temperature_title,
            action:up_or_down,
            beginTime:begin_time,
            endTime:end_time,
            changeBeginTime:change_begin_time,
            changeEndTime:change_end_time,
            firstMove:this.up_down_first
          }
        }).then(data=>{
          if(data.data.success==true){
            that.up_down_first=false
            //清空上一次的图表
            that.flushCharts()
            //生成折线图
            that.get_myCharts(data.data.data)
            that.myChart.dispatchAction({
              type: 'brush',
              areas: [
                {
                  brushType: 'lineX',
                  xAxisIndex: 0,
                  coordRange: [that.params_start_range, that.params_end_range],
                },
              ],
            })
          }else{
            that.$message.error(data.data.message)
          }
        })
      },
      //曲线上移
      draw_move_up(){
        if(this.drawXPoint.length>0){
          this.$message.warning('请先处理手绘曲线')
          return false
        }
        this.draw_move_fn('up')
      },
      //曲线下移
      draw_move_down(){
        if(this.drawXPoint.length>0){
          this.$message.warning('请先处理手绘曲线')
          return false
        }
        this.draw_move_fn('down')
      },
      //返回(取消绘制曲线)
      reBack(){
        this.hasOver='Y'
        this.draw_status=false
        this.draw_title='绘制曲线'
        this.chart_or_draw=false
        this.isMouseDown=false
      },
      //确认(确认所绘制曲线)
      confirmDrawing(){
        if(this.drawXPoint.length<this.totalPoint){//画的节点数小于总数表示没有画完
          this.$message.warning('曲线图尚未完成，不能保存')
          return;
        }
        this.drawYPoint=this.drawYPoint.slice(0,this.totalPoint)
        this.drawXPoint=this.drawXPoint.slice(0,this.totalPoint)
        this.hasOver='Y'
        let all_temperature=this.getAllTemperatureDataFromCanvasDrawingBoard()
        if(this.params_start==''){
          this.selected_temp_list=all_temperature
        }else{
          if(this.selected_temp_list.length==0){
            this.new_temp_list[0].forEach((item,index)=>{
              all_temperature.forEach((item1,index1)=>{
                if(item[0]==item1[0]){
                  item[1]=item1[1]
                }
              })
            })
            this.selected_temp_list=this.new_temp_list[0]
          }else{
            this.selected_temp_list.forEach((item,index)=>{
              all_temperature.forEach((item1,index1)=>{
                if(item[0]==item1[0]){
                  item[1]=item1[1]
                }
              })
            })
          }
        }
        this.draw_status=false
        this.draw_title='绘制曲线'
        this.chart_or_draw=false
        this.isMouseDown=false
        let that=this
        //清空上一次的图表
        that.flushCharts()
        //生成折线图
        that.get_myCharts(that.selected_temp_list,true)
        // that.myChart.setOption({
        //   series:[{
        //     id:'a',
        //     data:that.selected_temp_list
        //   }]
        // })
      },
      //获取整条曲线中所有点的温度和时间坐标
      getAllTemperatureDataFromCanvasDrawingBoard(){
        let temperatureList=[]
        for(let i=0;i<this.drawYPoint.length;i++){
          let time=new Date(this.sTime)
          time.setSeconds(time.getSeconds()+this.timeInterval*i)
          //计算当前x轴对应的时间节点
          let x=this.convertDateToYmdhms(time)
          //计算当前y轴坐标对应的温度
          this.maxTemperature=parseFloat(this.maxTemperature)
          this.minTemperature=parseFloat(this.minTemperature)
          let y=((this.canvasHeight - this.drawYPoint[i]) / this.canvasHeight) * (this.maxTemperature - this.minTemperature) + this.minTemperature
          y=parseFloat(y).toFixed(1)
          temperatureList.push([x,y])
        }
        return temperatureList
      },
      //将new Date转为yyyy-mm-dd hh:mm:ss\
      convertDateToYmdhms(sourceDate){
        return sourceDate.getFullYear() + "-" + this.checkTime(sourceDate.getMonth() + 1) + "-" + this.checkTime(sourceDate.getDate()) + " " + this.checkTime(sourceDate.getHours()) + ":" + this.checkTime(sourceDate.getMinutes())
      },
      //日期格式化
      checkTime(i){
        if(i<10){
          i='0'+i
        }
        return i
      },
      //清空上一次的图表
      flushCharts(){
        let lastedOption=this.myChart.getOption()
        if(lastedOption){
          for(let i = 0; i < lastedOption.series.length; i++){
            lastedOption.series[i].data=[]
            lastedOption.series[i].name=''
          }
          this.myChart.clear()
          this.myChart.setOption(lastedOption)
        }
      },
      //绘制曲线
      draw_curve(){
        if(this.up_down_first==false){
          this.$message.warning('请先保存上移或下移生成的曲线，再进行手绘！')
          return false
        }
        this.isCustom='Y'
        this.hasOver='N'
        if(!this.maxTemperature||typeof(this.minTemperature)=='string'){
          this.$message.warning('无法获取到设备的上下限温度')
          return false
        }
        if(this.selected_item.length!=1){
          this.$message.warning('每次只允许绘制一条曲线')
          return false
        }
        this.draw_status=!this.draw_status
        if(this.draw_status==true){
          this.draw_title='取消绘制'
        }else{
          this.draw_title='绘制曲线'
          this.chart_or_draw=false
          return false
        }
        this.draw_show=false
        this.chart_or_draw=true
        //初始化canvas要用到的数据
        if(this.params_start==''){
          this.initcanvas(new Date(this.time_form.date_range[0]),
          new Date(this.time_form.date_range[1]),
          60,this.minTemperature,
          this.maxTemperature,50,2,
          'manualDrawingCanvas')
        }else{
          this.initcanvas(new Date(this.params_start),
          new Date(this.params_end),
          60,this.minTemperature,
          this.maxTemperature,50,2,
          'manualDrawingCanvas')
        }
      },
      //初始化canvas要用到的数据
      //startTime:开始时间
      //endTime:结束时间
      //ti:间隔
      //mint:最小温度
      //maxt::最大温度
      //ml:第一个开始的坐标
      //ia:包容量
      //cvId:canvasJQ对象
      initcanvas(startTime, endTime, ti, mint, maxt, ml, ia, cvId){
        this.sTime=startTime
        this.eTime=endTime
        this.timeInterval=ti
        this.maxTemperature=maxt
        this.minTemperature=mint
        this.marginLeft=ml
        this.inclusiveAmount=ia
        this.canvas=document.getElementById(cvId)
        this.cxt=this.canvas.getContext('2d')
        this.canvasWidth=parseInt(this.canvas.width)
        this.canvasHeight=parseInt(this.canvas.height)
        this.totalPoint=(this.eTime.setSeconds(0)-this.sTime.setSeconds(0))/1000/this.timeInterval+1
        this.interval=parseFloat(((this.canvasWidth-100)/this.totalPoint).toFixed(2))
        if(this.interval==0){
          this.interval=0.1
        }
        let that=this
        if(that.params_start==''){
          that.scale_position_show=false
        }else{
          var sum1=that.scale_left-that.minTemperature*1
          var sum2=sum1/(that.maxTemperature-that.minTemperature)
          var sum3=sum2*that.canvasHeight
          var sum11=that.scale_right-that.minTemperature*1
          var sum22=sum11/(that.maxTemperature-that.minTemperature)
          var sum33=sum22*that.canvasHeight
          //选择曲线区域后，开始温度在canvas上的定位top值
          that.scale_left_position=that.canvasHeight-sum3
          //选择曲线区域后，结束温度在canvas上的定位top值
          that.scale_right_position=that.canvasHeight-sum33
          that.scale_position_show=true
        }
        //监听鼠标事件
        that.canvas.addEventListener('mousedown',function(e){
          that.isMouseDown=true
          that.DrawLine(e)
        },false)
        that.canvas.addEventListener('mouseup',function(e){
          that.isMouseDown=false
        },false)
        that.canvas.addEventListener('mousemove',function(e){
          let point=((that.canvasHeight-e.offsetY)/that.canvasHeight)*(that.maxTemperature-that.minTemperature)+that.minTemperature*1
          point=parseFloat(point.toString()).toFixed(2)
          that.mouseCurrentTemp=point
          that.DrawLine(e)
        },false)
        //重置画板
        this.reDrawing()
      },
      //重置画板
      reDrawing(){
        this.isMouseDown=false
        this.canvas.height=this.canvasHeight
        this.drawXPoint=[]
        this.drawYPoint=[]
        this.currentPoint=0
        this.shouldPoint=1
        this.cxt.moveTo(this.marginLeft,0)
        this.cxt.lineTo(this.marginLeft,400)
        this.cxt.stroke()
      },
      //取点画线
      DrawLine(e){
        //当前点不是最后一个点
        let boolFlag=this.currentPoint!=this.totalPoint
        if(boolFlag){
          //离鼠标最近的下一个点
          this.shouldPoint=parseInt((e.offsetX-this.marginLeft)/this.interval)+1
          //上述点的x坐标(shouldpoint-1是因为+marginleft相当于shouldpoint+1)
          this.shouldBeIndex=parseFloat((this.marginLeft+(this.shouldPoint-1)*this.interval).toFixed(2))
          //x坐标是否在上述点附近
          let b1=e.offsetX>=this.shouldBeIndex-this.inclusiveAmount&&e.offsetX<=this.shouldBeIndex+this.inclusiveAmount
          //x坐标是否已经被记录
          let b2=this.drawXPoint.indexOf(this.shouldBeIndex)<0
          //x坐标是否处在允许绘制的区域
          let b3=e.offsetX>=this.marginLeft
          //x坐标是否大于允许绘制的区域
          let b4=e.offsetX>=this.canvasWidth-this.marginLeft
          if(b4){
            this.shouldPoint=this.totalPoint
          }
          if(b1&&b2&&b3&&this.isMouseDown){
            let yIndex=e.offsetY
            let yInterval=0
            if(this.drawYPoint.length>0){
              yIndex=this.drawYPoint[this.drawYPoint.length-1]
              yInterval=(this.drawYPoint[this.drawYPoint.length-1]-e.offsetY)/(this.shouldPoint-this.currentPoint)
            }
            //循环从应该打的点到当前鼠标所在点的所有坐标
            for(let i=0;i<this.shouldPoint-this.currentPoint;i++){
              let itemIndex=parseFloat((this.marginLeft+(this.currentPoint+i)*this.interval).toFixed(2))
              this.drawXPoint.push(itemIndex)
              this.drawYPoint.push((yIndex - yInterval * (i + 1)))
            }
            this.currentPoint=this.shouldPoint
            //刷新canvas
            this.refreshCanvas()
          }
        }
      },
      //刷新canvas
      refreshCanvas(){
        this.canvas.height=this.canvas.height
        this.cxt.moveTo(this.drawXPoint[0],this.drawYPoint[0])
        this.cxt.beginPath()
        this.cxt.arc(this.drawXPoint[0],this.drawYPoint[0],1,0,360,false)
        this.cxt.fill()//画实心圆
        for(let i=1;i<this.drawXPoint.length;i++){
          this.cxt.lineTo(this.drawXPoint[i],this.drawYPoint[i])
          this.cxt.stroke()
          this.cxt.beginPath()
          this.cxt.arc(this.drawXPoint[i],this.drawYPoint[i],1,0,360,false)
          this.cxt.fill()//画实心圆
          this.cxt.moveTo(this.drawXPoint[i],this.drawYPoint[i])
        }
        if(this.currentPoint<this.totalPoint){
          //画引导竖线
          this.drawVerticalLine()
        }
      },
      //画引导竖线
      drawVerticalLine(){
        this.cxt.moveTo(this.shouldBeIndex+this.interval,0)
        this.cxt.lineTo(this.shouldBeIndex+this.interval,400)
        this.cxt.stroke()
        this.cxt.moveTo(this.drawXPoint[this.drawXPoint.length-1],this.drawYPoint[this.drawYPoint.length-1])
      },
      //将base64转换为file
      dataURLtoFile(dataurl,filename){
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bStr = atob(arr[1]), n = bStr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bStr.charCodeAt(n)
        }
        return new File([u8arr], filename, {type: mime})
      },
      //保存绘制的曲线
      save_data(){
        let selected_now_temp_list=[]
        if(this.isCustom=='Y'&&this.hasOver=='N'){
          this.$message.warning('请先点击确认按钮，再保存')
          return false
        }
        if(this.selected_temp_list.length==0){
          selected_now_temp_list=this.new_temp_list[0]
        }else{
          selected_now_temp_list=this.selected_temp_list
        }
        let temps=[]
        selected_now_temp_list.forEach(item=>{
          let temp={}
          temp.recordTime=Date.parse(new Date(item[0]).toString())
          temp.temperature=item[1]
          temps.push(temp)
        })
        let postSavedJson={
          pointId:this.temperature_title,
          recordList:temps
        }
        let that=this
        that.$confirm('确定保存温度数据么?',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'post',
            url:that.publicAjax.extra_path+'/middle/warehousePoint/saveData',
            data:JSON.stringify(postSavedJson),
            headers:{
              "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
              "content-type":"application/json;charset=UTF-8"
            }
          }).then(data=>{
            if(data.data.success==true){
              that.$message.success(data.data.message)
              this.up_down_first=true
              this.draw_move_btn=false
              this.drawXPoint=[]
              this.drawYPoint=[]
              //获取温度数据
              that.get_temp()
            }else{
              that.$message.error(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //获取曲线明细列表
      get_curve_list(){
        this.curve_show=true
        if(this.curve_detail_list.length==1){
          this.curve_detail_data=this.curve_detail_list[0]
        }else if(this.curve_detail_list.length>1){
          this.curve_detail_data=this.curve_detail_list
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .search_form .el-form-item{
    width: 49%;
    display: inline-block;
    @media screen and (max-width:720px) {
      width: 100%;
    }
  }
  .search_form .el-form-item:last-child{
    width: 100%;
  }
  // 右键菜单
  #warehouse_menu{
    position: fixed;
    display: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    background: #FFFFFF;
    cursor: pointer;
    color: #606266;
    width: 200px;
    border: 1px solid #e4e7ed;
    font-size: 14px;
    z-index: 999;
    ul{
      list-style: none;
      margin: 0px;
      padding: 0px;
      li{
        padding: 0px 10px;
        height: 30px;
        line-height: 30px;
        position: relative;
        box-sizing: border-box;
        text-indent: 8px;
      }
      li:hover{
        background-color: #ecf5ff;
      }
    }
  }
  // 温度数据
  #chart{
    width: 1000px;
    height: 550px;
    margin-left: -10px;
    zoom: 1.25;
  }
  .chart_btn_group{
    position: absolute;
    right: 0px;
    top: 20px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    i{
      cursor: pointer;
      font-size: 30px;
      margin-bottom: 20px;
    }
    .el-icon-edit{
      color: #409EFF;
    }
  }
  /* 绘制曲线样式 */
  .draw_edit_ture{
    font-style: normal;
    color: #131974 !important;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/warehouse_manage.vue